<template>
  <b-container fluid>
    <b-row v-if="onlineAdmission">
      <b-col lg="12" sm="12">
            <b-row>
                <b-col xs="12" sm="12" md="12" class="text-right mb-2">
                    <b-button @click="pdfExport()" variant="success">{{  $t('globalTrans.export_pdf') }}</b-button>
                </b-col>
            </b-row>
            <template>
                <div style="font-size: 16px; background-color: rgb(51, 121, 130);">
                    <h5 class="text-white text-center"> {{ $t('drop_release.title') }}</h5>
                </div>
            </template>
            <b-table-simple striped bordered small hover class="request_dtls_wrapper">
                <tbody>
                     <b-tr>
                        <b-th>{{ $t('globalTrans.year')}}</b-th>
                        <b-td colspan="3">{{ $n(onlineAdmission.year_id, { useGrouping: false }) }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th>{{ $t('globalTrans.organization')}} </b-th>
                        <b-td colspan="3">{{ getOrgName(onlineAdmission.org_name_id) }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th>{{ $t('child_configuration.institute_type')}} </b-th>
                        <b-td>{{ getInstituteType(onlineAdmission.inst_type_id) }} </b-td>
                        <b-th>{{ $t('child_configuration.institute_name')}} </b-th>
                        <b-td>{{ getInstituteName(onlineAdmission.inst_name_id) }} </b-td>
                    </b-tr>
                    <b-tr>
                        <b-th>{{ $t('child_admission_management.name')}} </b-th>
                        <b-td>{{ (currentLocale === 'en') ? onlineAdmission.name_en : onlineAdmission.name_bn }}</b-td>
                        <b-th>{{ $t('child_admission_management.religion')}} </b-th>
                        <b-td>{{ parseInt(onlineAdmission.religion) > 0 ? getRegionName(onlineAdmission.religion) : '' }} </b-td>
                    </b-tr>
                     <b-tr>
                        <b-th>{{ $t('child_admission_management.father_name')}} </b-th>
                        <b-td>{{ (currentLocale === 'en') ? onlineAdmission.father_en : onlineAdmission.father_bn }}</b-td>
                        <b-th>{{ $t('child_admission_management.mother_name')}} </b-th>
                        <b-td>{{ (currentLocale === 'en') ? onlineAdmission.mother_en : onlineAdmission.mother_bn }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th>{{ $t('child_admission_management.nationality')}} </b-th>
                        <b-td>{{ (currentLocale === 'en') ? onlineAdmission.nationality_en : onlineAdmission.nationality_bn }}</b-td>
                        <b-th>{{ $t('child_admission_management.highest_qualification')}} </b-th>
                        <b-td>{{ (currentLocale === 'en') ? onlineAdmission.qualification_en : onlineAdmission.qualification_bn }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th>{{ $t('online_admission.physical_disability')}} </b-th>
                        <b-td colspan="3">{{ (currentLocale === 'en') ? onlineAdmission.phy_disability_en : onlineAdmission.phy_disability_bn }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th>{{ $t('online_admission.disability_description')}} </b-th>
                        <b-td colspan="3">{{ (currentLocale === 'en') ? onlineAdmission.disability_description_en : onlineAdmission.disability_description_bn }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th>{{ $t('child_admission_management.date_of_birth')}} </b-th>
                        <b-td>{{ onlineAdmission.birth_date | dateFormat }} </b-td>
                        <b-th>{{ $t('online_admission.birth_certificate_no')}} </b-th>
                        <b-td>{{ onlineAdmission.birth_certificate_no | mobileNumber }} </b-td>
                    </b-tr>
                    <b-tr>
                        <b-th>{{ $t('ds_institute_management.class')}} </b-th>
                        <b-td>{{ getClassName(onlineAdmission.class_id) }} </b-td>
                        <b-th>{{ $t('ds_student_management.student_roll')}} </b-th>
                        <b-td>{{ $n(onlineAdmission.student_id, { useGrouping: false }) }} </b-td>
                    </b-tr>
                    <b-tr>
                        <b-th>{{ $t('ds_institute_management.contact_no')}} </b-th>
                        <b-td>{{ onlineAdmission.mobile_no | mobileNumber }} </b-td>
                        <b-th>{{ $t('training.date')}} </b-th>
                        <b-td>{{ onlineAdmission.date | dateFormat }} </b-td>
                    </b-tr>
                    <!-- <b-tr>
                        <b-th>{{ $t('ds_institute_management.address')}} </b-th>
                        <b-td colspan="3">{{ onlineAdmission.address }}</b-td>
                    </b-tr> -->
                    <b-tr>
                        <b-th>{{ $t('training.reason')}} </b-th>
                        <b-td colspan="3">{{ (currentLocale === 'en') ? onlineAdmission.reason : onlineAdmission.reason_bn }}</b-td>
                    </b-tr>
                </tbody>
            </b-table-simple>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { disabilitySchoolServiceBaseUrl } from '@/config/api_config'
import ExportPdf from './export-pdf'
export default {
  props: ['id'],
  created () {
    if (this.id) {
      const tmp = this.getCommittee()
      if (tmp) {
        this.onlineAdmission = tmp
      }
    }
  },
  data () {
    return {
      onlineAdmission: null
    }
  },
  computed: {
    currentLocale () {
      return this.$i18n.locale
    }
  },
  methods: {
        getOrgName (orgId) {
        const tmpData = this.$store.state.commonObj.organizationProfileList.find(item => item.value === parseInt(orgId))
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
        },
        getInstituteType (Id) {
            const tmpData = this.$store.state.commonObj.officeTypeList.find(item => item.value === Id)
            if (this.$i18n.locale === 'bn') {
                return tmpData.text_bn
            } else {
                return tmpData.text_en
            }
        },
        getInstituteName (Id) {
            const tmpData = this.$store.state.commonObj.officeList.find(item => item.value === Id)
            if (this.$i18n.locale === 'bn') {
                return tmpData.text_bn
            } else {
                return tmpData.text_en
            }
        },
        getStudentType (typeId) {
            const Type = this.$store.state.ChildService.DisabilitySchoolService.commonObj.studentTypeList.find(type => type.value === typeId)
            if (this.$i18n.locale === 'bn') {
                return Type.text_bn
            } else {
                return Type.text_en
            }
        },
          getRegionName (Id) {
            const tmpData = this.$store.state.commonObj.religionList.find(item => item.value === parseInt(Id))
            if (this.$i18n.locale === 'bn') {
                return tmpData.text_bn
            } else {
                return tmpData.text_en
            }
        },
        getGenderName (Id) {
            const tmpData = this.$store.state.DisabilitySchoolService.commonObj.genderList.find(item => item.value === parseInt(Id))
            if (this.$i18n.locale === 'bn') {
                return tmpData.text_bn
            } else {
                return tmpData.text_en
            }
        },
           getClassName (Id) {
            const Obj = this.$store.state.DisabilitySchoolService.commonObj.classList.find(item => item.value === parseInt(Id))
            if (this.$i18n.locale === 'bn') {
                return Obj.text_bn
            } else {
                return Obj.text_en
            }
        },
    getCommittee () {
      const tmpData = this.$store.state.list.find(item => item.id === this.id)
      return tmpData !== undefined ? JSON.parse(JSON.stringify(tmpData)) : null
    },
     pdfExport () {
            const reportTitle = this.$t('drop_release.titles') + ' ' + this.$t('globalTrans.details') + ' ' + this.$t('sidebar.information')
            ExportPdf.exportPdfDetails(disabilitySchoolServiceBaseUrl, 'configuration/report-heading/detail', this.onlineAdmission.org_name_id, reportTitle, this.onlineAdmission, this)
        }
    /** End Details */
  }
}
</script>
<style scoped>
.request_dtls_wrapper tr th {
  width: 20%;
}
.request_dtls_wrapper tr td {
  width: 30%;
}
</style>
